import * as Handlebars from 'handlebars/runtime';
import deviceTypeIcon from 'templates/partials/deviceTypeIcon';
import navbar from 'templates/partials/navbar';
Handlebars.registerHelper({});
Handlebars.registerPartial({deviceTypeIcon,navbar});
export default Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "\n<div class=\"card log\"></div>\n\n<form class=\"form\">\n	<input class=\"form-control messageInput\" type=\"text\" placeholder=\"Type in your message...\"></input>\n	<button class=\"btn btn-primary submitButton\">Send</button>\n</form>\n";
},"useData":true});